export default "__VITE_ASSET__D68xkVJY__"